import { createFileRoute, redirect } from '@tanstack/react-router';

import { projectLanding } from '@/app/landing';
import { getSession } from '@/lib/auth/session';

/** Field roles land on Site › Today; owner-side roles on the Overview. */
export const Route = createFileRoute('/_app/projects/$projectId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: projectLanding(getSession().me, params.projectId),
      params,
      replace: true,
    });
  },
});
